import React from 'react';
import CalculatorAssumptions from './CalculatorAssumptions';

class CalculatorLayout extends React.Component {
  constructor(props) {
    super(props);
    this.formColumn = React.createRef();
    this.resultsColumn = React.createRef();
    this.handleScroll = this.handleScroll.bind(this);
  }

  desktopMinWidth = 992;
  
  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
    document.addEventListener('resize', this.handleResize);
  }
  
  componentWillUnmount() {
    document.removeEventListener('scroll'. this.handleScroll);
    document.removeEventListener('resize', this.handleResize);
  }
  
  handleResize() {
    if (window.innerWidth < this.desktopMinWidth) {
      this.formColumn.current.style.marginTop = '0';
      this.resultsColumn.current.style.marginTop = '0';
    }
  }
  
  handleScroll() {
    if (!this.resultsColumn.current.children.length) {
      // to prevent scrolling issues while calculator results are not loaded
      return;
    }
    if (window.innerWidth >= this.desktopMinWidth) {
      const resultsColumnRect = this.resultsColumn.current.getBoundingClientRect();
      const formColumnRect = this.formColumn.current.getBoundingClientRect();
      const [longerColumnRect, shorterColumnRect, resultsColumnLonger] = resultsColumnRect.height > formColumnRect.height ? [resultsColumnRect, formColumnRect, true] : [formColumnRect, resultsColumnRect, false];
      if(longerColumnRect.y < 0) {
        const maxMarginTop = longerColumnRect.height - shorterColumnRect.height;
        const newMarginTop = Math.min(-longerColumnRect.y, maxMarginTop);
        if (resultsColumnLonger) {
          this.formColumn.current.style.marginTop = newMarginTop.toString() + 'px';
        } else {
          this.resultsColumn.current.style.marginTop = newMarginTop.toString() + 'px';
        }
      } else {
        if (resultsColumnLonger) {
          this.formColumn.current.style.marginTop = '0';
        } else {
          this.resultsColumn.current.style.marginTop = '0';
        }
      } 
    } 
  }

  render() {
    return (
      <div className="calculator-layout">
        <div className="calculator-layout__info-row">
          {this.props.infoRow}
        </div>
        <div className="calculator-layout__columns-flex">
          <div className="calculator-layout__column-wrapper form-wrapper">
            <div className="calculator-layout__form-column" ref={this.formColumn}>
              {this.props.formColumn}
            </div>
              {this.props.children}
          </div>
          <div className="calculator-layout__column-wrapper results-wrapper">
            <div className="calculator-layout__results-column" ref={this.resultsColumn}>
              {this.props.resultsColumn}
            </div>
            {this.props.calculatorAsterisk}
          </div>
        </div>
      </div>
    )
  }
}

export default CalculatorLayout;
